module.exports = __webpack_public_path__ + "img/image17.9a12ab45.jpg";